import React, { forwardRef, useState, useEffect } from 'react'
import styled from 'styled-components'

import { Input } from '../Forms'
import { Box } from '../Grid'

import useDebounce from '../../utils/debounce'

const Wrapper = styled(Box)`
  position: relative;

  input {
    box-sizing: border-box;
  }

  > span {
    pointer-events: none;
  }
`

const Search = forwardRef(function Search({ active, onChange, onFocus, onKeyUp, ...props }, ref) {
  const [searchTerm, setSearchTerm] = useState('')
  const debouncedSearchTerm = useDebounce(searchTerm, 250)
  useEffect(() => {
    onChange && onChange(searchTerm)
  }, [debouncedSearchTerm])

  useEffect(() => {
    if (active) {
      ref.current.focus()
    }
  }, [active])

  return (
    <Wrapper fontSize="14px" pt={1} {...props}>
      <Input
        name="search"
        inputStyle={active ? 'base' : 'inactive'}
        ref={ref}
        type="search"
        onChange={setSearchTerm}
        onKeyUp={onKeyUp}
        onFocus={onFocus}
        placeholder="Search"
        autoComplete="off"
      />
    </Wrapper>
  )
})

export default Search
